import React from 'react';

interface SkeletonProps {
  className?: string;
  /** Se true, usa rounded-full (ex: avatar). Default: rounded-md. */
  circle?: boolean;
}

/**
 * Bloco animado de loading. Use `className` para definir largura/altura
 * via classes Tailwind (`h-6 w-24`, etc).
 */
export function Skeleton({ className = '', circle }: SkeletonProps) {
  return (
    <div
      aria-hidden
      className={[
        'animate-pulse bg-surface-alt dark:bg-surface-dark-alt',
        circle ? 'rounded-full' : 'rounded-md',
        className,
      ].join(' ')}
    />
  );
}
